import React from 'react';

import { ActionableRateCard } from '../../../../rate-card/actionable/actionable-rate-card';
import { ActionButton } from './action-button';

export const FulfillmentPlanActionableRateCard = () => {
  return <ActionableRateCard ActionButton={ActionButton} />;
};
